exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.bg-primary[data-v-c1a7d0b2] {\n  background-color: #822023 !important;\n}\n.text-dark[data-v-c1a7d0b2] {\n  font-weight: 600;\n  font-size: 12pt;\n  color: #000 !important;\n}\n#cancelInvoicesModal[data-v-c1a7d0b2] {\n  margin-top: 85px !important;\n}\n@media (min-width: 1400px) {\n.container[data-v-c1a7d0b2] {\n    width: 1360px;\n    max-width: 100%;\n}\n}\n@media (min-width: 1680px) {\n.container[data-v-c1a7d0b2] {\n    width: 1640px;\n    max-width: 100%;\n}\n}\n@media (min-width: 1920px) {\n.container[data-v-c1a7d0b2] {\n    width: 1860px;\n    max-width: 100%;\n}\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":false,"sourceMap":false}!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-c1a7d0b2","scoped":true,"hasInlineConfig":false}!./~/sass-loader/lib/loader.js?{"sourceMap":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/home/invoices/Invoices.vue
// module id = 690
// module chunks = 1